
import { Vue } from "vue-class-component";

export default class DropPackage extends Vue {}
